export const environment = {
  apiUrl: 'https://dev-recruiting.coders.cx/api/v2',
  production: true,
};
